import { render, staticRenderFns } from "./PasswordResetIcon.vue?vue&type=template&id=243687e1&scoped=true&"
import script from "./PasswordResetIcon.vue?vue&type=script&lang=js&"
export * from "./PasswordResetIcon.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetIcon.vue?vue&type=style&index=0&id=243687e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243687e1",
  null
  
)

export default component.exports